import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterFiltration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 21.75H8.864C8.4908 21.7499 8.13103 21.6108 7.85496 21.3596C7.57888 21.1085 7.40633 20.7635 7.371 20.392L6 6L3 2.25L18 3.75V20.25C18 20.6478 17.842 21.0294 17.5607 21.3107C17.2794 21.592 16.8978 21.75 16.5 21.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 3.75H20.25C21.0456 3.75 21.8087 4.06607 22.3713 4.62868C22.9339 5.19129 23.25 5.95435 23.25 6.75V9C23.2499 10.4534 22.7222 11.8573 21.765 12.951L18 17.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 18H18",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 10.5C3.75 10.8978 3.59196 11.2794 3.31066 11.5607C3.02936 11.842 2.64782 12 2.25 12C1.85218 12 1.47064 11.842 1.18934 11.5607C0.908035 11.2794 0.75 10.8978 0.75 10.5C1.10258 9.19596 1.60598 7.93747 2.25 6.75C2.89402 7.93747 3.39742 9.19596 3.75 10.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWaterFiltration;
